import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { getAllCountryData } from "../../../redux/actions/countryCityActions";
import {
  get_merchant_list,
  get_merchant_details_id
} from "../../../redux/actions/merchantActions";
import { getPayoutDropdownList } from "../../../redux/actions/payoutActions";
import {
  add_product,
  getProductDetails,
  update_product,
  clone_product_detail,
  clone_product,
  ContractType
} from "../../../redux/actions/contractActions";
import { getSalesPersons } from "../../../redux/actions/salesPersonActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import loader from "../../../style/loader/loader.scss";
import auth from "../../../services/auth";

import AdditionalPrice from "./AdditionalPrice";
import Attributes from "./Attributes";
import {aclUtil} from "../../util";
import NumberFormat from "react-number-format";
let xCoordinate = {},
yCoordinate = {};

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  countries: PropTypes.array.isRequired,
  get_merchant_list: PropTypes.func.isRequired,
  getProductDetails: PropTypes.func.isRequired,
  update_product: PropTypes.func.isRequired,
  clone_product_detail: PropTypes.func.isRequired,
  clone_product: PropTypes.func.isRequired,
  get_merchant_details_id: PropTypes.func.isRequired
};

let cityItems = [];
let isLoading = "false";
let userinfo = "";
let priceIndex = 0;
let form = [];
let offerTitle = [],
  r_offerTitle = [],
  french_offerTitle = [],
  minQuantity = [],
  activateQuantity =[],
  skuCode = [],
  maxPerCustomer = [],
  percentageOff = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  freeShipping = [],
  shippingAmount = [],
  shippingAmountMerchant = [],
  shippingAmountAdmin = [],
  maxAsGift = [],
  attributeData = [],
  contractID = [];
let additionalPriceDetail = [],
  contractIdParams,
  contractTypeParams,
  contract,
  matrixData = [];

class AddProduct extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_PRODUCTS',
      path: ["Home", "Manage Product", "Add New"],
      links:["home", "productList",'addProduct'],
      startDate: moment(),
      countryData: [],
      statesName: [],
      citiesName: [],
      contractID: "",
      cityID: "",
      offerTitle: "",
      french_offerTitle: "",
      percentageOff: "",
      maxAvailable: "",
      retailPrice: "",
      offerPrice: "",
      remittance: "",
      freeShipping: "0",
      shippingAmount: "",
      shippingAmountMerchant: "",
      shippingAmountAdmin: "",
      maxPerCustomer: "",
      maxAsGift: "",
      minQuantity: "1",
      activateQuantity:"",
      skuCode: "",
      merchantID: "",
      merchantLegalName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      phone: "",
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      notes: "",
      redeemedAtCall: "0",
      redemptionCodeReq: "0",
      shipable: "0",
      vouchersBeIssued: "instantly",
      alertMessage: "",
      countryName: "United States",
      coupoOption: false,
      service: "",
      pricing: "",
      creditCardType: "",
      creditCardNumber: "",
      cardExpirationDate: "",
      securityNumber: "",
      affiliateOption: false,
      affiliatePurchaseUrl: "",
      paymentType: "Fixed Fee",
      paymentAmount: "",
      paymentReceived: "0",
      paymentAmountReceived: "",
      paymentAmountReceivedStatus: false,
      contractType: "10",
      disabled: false,
      submitValue: "Save",
      show: false,
      changeDate: false,
      salesManagerID: "",
      salespersonlist: [],
      priceIndex: [],
      attributeStatus: false,
      attributes: [],
      clearAttributes: false,
      payoutList: '',
      deatil: '',
      multi_lang: 'no',
      addCity: "",
      addState: "",
      hideMsg: false
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateDates = this.handleUpdateDates.bind(this);
    this.handleChangeMerchant = this.handleChangeMerchant.bind(this);
    this.handleChangeContract = this.handleChangeContract.bind(this);
    this.handlePaymentReceived = this.handlePaymentReceived.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.addPricingDetail = this.addPricingDetail.bind(this);
  }
  /*
   * Start multiple price management
   */

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };
  addPricingDetail = e => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        handleOfferChange={this.handleOfferChange}
        handleFrenchOfferChange={this.handleFrenchOfferChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleActiveQuantityChange={this.handleActiveQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlepercentageOffChange={this.handlepercentageOffChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleremittanceChange={this.handleremittanceChange}
        handlefreeShippingChange={this.handlefreeShippingChange}
        handleshippingAmountChange={this.handleshippingAmountChange}
        handleshippingAmountMerchantChange={this.handleshippingAmountMerchantChange}
        handleshippingAmountAdminChange={this.handleshippingAmountAdminChange}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        attributeData={this.attributeData}
        priceData=""
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
        key={Math.random()}
      />
    ); 
    this.setState({ priceIndex: form });
  };

  editPricingDetail = data => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        key={Math.random()}
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        affiliateOption={this.state.affiliateOption}
        handleOfferChange={this.handleOfferChange}
        handleFrenchOfferChange={this.handleFrenchOfferChange}
        handleminQuantityChange={this.handleminQuantityChange}
        handleActiveQuantityChange={this.handleActiveQuantityChange}
        handleskuCodeChange={this.handleskuCodeChange}
        handlemaxPerCustomerChange={this.handlemaxPerCustomerChange}
        handlepercentageOffChange={this.handlepercentageOffChange}
        handlemaxAvailableChange={this.handlemaxAvailableChange}
        handleretailPriceChange={this.handleretailPriceChange}
        handleofferPriceChange={this.handleofferPriceChange}
        handleremittanceChange={this.handleremittanceChange}
        handlefreeShippingChange={this.handlefreeShippingChange}
        handleshippingAmountChange={this.handleshippingAmountChange}
        handleshippingAmountMerchantChange={this.handleshippingAmountMerchantChange}
        handleshippingAmountAdminChange={this.handleshippingAmountAdminChange}
        handlemaxAsGiftChange={this.handlemaxAsGiftChange}
        attributeData={this.attributeData}
        priceData={data}
        handleUpdate={this.handleUpdate}
        validationError={this.state.additionalError}
        matrixData={this.matrixData}
        key={Math.random()}
      />
    );
    maxAvailable[priceIndex] = data.maxAvailable;
    r_offerTitle[priceIndex] = data.offerTitle;
    //console.log('r_offerTitle1', r_offerTitle);
    //offerTitle[priceIndex] = data.offerTitle;
    this.setState({ priceIndex: form });
  };

  handleUpdate = (field, value, index, contractID) => {
    let newIdx = index - 1;

    if(field == 'attributes'){
      field = 'attribute';
    }
    if(field == 'maxAvailable'){
      maxAvailable[index] = value;
    }

    const newContract = this.state.contract.map((data, pidx) => {
      if (newIdx !== pidx) return data;
      return { ...data, [field]: value };
    });
    this.setState({ contract: newContract });
  };

  handleChangeAditionalPrice = e => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "offerTitle") {
      this.handleOfferChange(e.target.value, 0);
    }
    if (e.target.name == "french_offerTitle") {
      this.handleFrenchOfferChange(e.target.value, 0);
    }
    if (e.target.name == "minQuantity") {
      this.handleminQuantityChange(e.target.value, 0);
    }

    if (e.target.name == "activateQuantity"){
      this.handleActiveQuantityChange(e.target.value, 0);
    }

    if (e.target.name == "skuCode") {
      this.handleskuCodeChange(e.target.value, 0);
    }
    if (e.target.name == "maxPerCustomer") {
      this.handlemaxPerCustomerChange(e.target.value, 0);
    }
    if (e.target.name == "percentageOff") {
      this.handlepercentageOffChange(e.target.value, 0);
      const hideMsg = e.target.value > 100 ? true : false; 
      this.setState({ hideMsg: hideMsg});
    }
    if (e.target.name == "maxAvailable") {
      this.handlemaxAvailableChange(e.target.value, 0);
    }
    if (e.target.name == "retailPrice") {
      this.handleretailPriceChange(e.target.value, 0);
    }
    if (e.target.name == "offerPrice") {
      this.handleofferPriceChange(e.target.value, 0);
    }
    if (e.target.name == "remittance") {
      this.handleremittanceChange(e.target.value, 0);
    }
    if (e.target.name == "freeShipping") {
      if(e.target.value === "1"){
        this.setState({ shippingAmountAdmin: 0,shippingAmountMerchant: 0,shippingAmount: 0,shipable: 1, });
      }else{
        this.setState({ shipable: 0 });
      }
      this.handlefreeShippingChange(e.target.value, 0);
    }
    if (e.target.name == "shippingAmount") {
      this.handleshippingAmountChange(e.target.value, 0);
    }
    if (e.target.name == "shippingAmountMerchant") {
      this.handleshippingAmountMerchantChange(e.target.value, 0);
    }
    if (e.target.name == "shippingAmountAdmin") {
      this.handleshippingAmountAdminChange(e.target.value, 0);
    }
    if (e.target.name == "maxAsGift") {
      this.handlemaxAsGiftChange(e.target.value, 0);
    }

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  };

  handleShippingPercent = e => {
    let shippingAmountAdminConst,
    shippingAmountMerchantConst,
    sumOfPercent = 0.0;
    if (this.state.shippingAmountAdmin || this.state.shippingAmountMerchant) {
      shippingAmountAdminConst =
      this.state.shippingAmountAdmin !== 0 &&
      typeof this.state.shippingAmountMerchant !== "NaN"
      ? Number.parseFloat(this.state.shippingAmountAdmin)
      : 0;
      shippingAmountMerchantConst =
      this.state.shippingAmountMerchant !== 0 &&
      typeof this.state.shippingAmountMerchant !== "NaN"
      ? Number.parseFloat(this.state.shippingAmountMerchant)
      : 0;

      sumOfPercent = shippingAmountAdminConst + shippingAmountMerchantConst;
      if (sumOfPercent !== 100) {
        this.setState({
          shippingAmountAdminError: "red",
          shippingAmountMerchantError: "red"
        });
        if (e.target.name === "shippingAmountMerchant") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        } else if (e.target.name === "shippingAmountAdmin") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        }
      }else if (sumOfPercent === 100) {
        this.setState({
          shippingAmountMerchantTooltipError: "",
          shippingAmountAdminTooltipError: "",
          shippingAmountMerchantError: "",
          shippingAmountAdminError: ""
        });
      }
    }
  };

  removePriceDetail = (id, contractID) => {
    if(contractID != ''){
      let newID = id - 1;
      let contractData = this.state.contract;
      delete contractData[newID];
      this.setState({ contract: contractData });

      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });
    }else{
      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });

      delete offerTitle[id];
      delete french_offerTitle[id];
      delete minQuantity[id];
      delete activateQuantity[id];
      delete skuCode[id];
      delete maxPerCustomer[id];
      delete percentageOff[id];
      delete maxAvailable[id];
      delete retailPrice[id];
      delete offerPrice[id];
      delete remittance[id];
      delete freeShipping[id];
      delete shippingAmount[id];
      delete shippingAmountMerchant[id];
      delete shippingAmountAdmin[id];
      delete maxAsGift[id];
      delete priceIndex[id];
    }
  };

  handleContractIDChange = (data, idx) => {
    contractID[idx] = data;
  };

  handleFrenchOfferChange = (offerTitleData, idx) => {
    french_offerTitle[idx] = offerTitleData;
  };

  handleOfferChange = (offerTitleData, idx) => {
    offerTitle[idx] = offerTitleData;
    r_offerTitle[idx] = offerTitleData;
    //console.log('r_offerTitle2', r_offerTitle);
  };

  handleminQuantityChange = (minQuantityData, idx) => {
    minQuantity[idx] = minQuantityData;
  };

  handleActiveQuantityChange = (activateQuantitydata, idx) => {
    activateQuantity[idx] = activateQuantitydata;
  };

  handleskuCodeChange = (skuCodeData, idx) => {
    skuCode[idx] = skuCodeData;
  };
  handlemaxPerCustomerChange = (maxPerCustomerData, idx) => {
    maxPerCustomer[idx] = maxPerCustomerData;
  };
  handlepercentageOffChange = (percentageOffData, idx) => {
    percentageOff[idx] = percentageOffData;
  };
  handlemaxAvailableChange = (maxAvailableData, idx) => {
    maxAvailable[idx] = maxAvailableData;
  };
  handleretailPriceChange = (retailPriceData, idx) => {
    retailPrice[idx] = retailPriceData;
  };
  handleofferPriceChange = (offerPriceData, idx) => {
    offerPrice[idx] = offerPriceData;
  };
  handleremittanceChange = (remittanceData, idx) => {
    remittance[idx] = remittanceData;
  };

  handlefreeShippingChange = (freeShippingData, idx) => {
    freeShipping[idx] = freeShippingData;
  };
  handleshippingAmountChange = (shippingAmountData, idx) => {
    shippingAmount[idx] = shippingAmountData;
  };
  handleshippingAmountMerchantChange = (shippingAmountMerchantData, idx) => {
    shippingAmountMerchant[idx] = shippingAmountMerchantData;
  };
  handleshippingAmountAdminChange = (shippingAmountAdminData, idx) => {
    shippingAmountAdmin[idx] = shippingAmountAdminData;
  };

  handlemaxAsGiftChange = (maxAsGiftData, idx) => {
    maxAsGift[idx] = maxAsGiftData;
    let result = maxAsGift.some(el => el > 0);
    if(result){
      this.setState({redeemedAtCall: 1});
    }else{
      this.setState({redeemedAtCall: 0});
    }
  };

  attributeData = (data, idx) => {
    if(idx==0){
      this.setState({attributes:data});
    }
    attributeData[idx] = data;
  };

  matrixData = (data, idx) => {
    matrixData[idx] = data;
  };

  /*
   * End multiple price management
   */

  handleUpdateDates(date) {
    this.setState({ disabled: false });
    const dates = moment();
    if (date) {
      const dates = date;
      this.setState({
        startDate: dates,
        changeDate: true
      });
    } else {
      this.setState({
        changeDate: false
      });
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePaymentReceived(e) {
    this.setState({ disabled: false });
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "1") {
      this.setState({ paymentAmountReceivedStatus: true });
    } else {
      this.setState({ paymentAmountReceivedStatus: false });
    }
  }

  handleChangeMerchant(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      merchantLegalName: "",
      address1: "",
      address2: "",
      phone: "",
      contactEmail: "",
      contactPhone: "",
      contactName: "",
      zip: "",
      city: "",
      country: "",
      cityID: "",
      state: "",
      addState: "",
      addCity: ""
    });
    this.props.get_merchant_details_id({merchantId : e.target.value});
  }

  handleChangeContract(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "6") {
      this.setState({ coupoOption: true });
      this.setState({ affiliateOption: false });
    } else if (e.target.value === "7") {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: true });
    } else {
      this.setState({ coupoOption: false });
      this.setState({ affiliateOption: false });
    }
  }

  // Handle input onchange
  handleChange(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    xCoordinate = {}
    yCoordinate = {}
    let checksMaxAvailable = true; 
    let shippingAmountAdminConst,
    shippingAmountMerchantConst,
    sumOfPercent = 0.0;
    maxAvailable.map((data, index) => { 
      if(typeof data == 'undefined' || data == '' || data == null) {
        checksMaxAvailable = false 
      } 
    });
    let totalMaxAvailable = 0;
    if(maxAvailable.length == 0 || typeof maxAvailable[0] == 'undefined' || maxAvailable.length != offerTitle.length){
      checksMaxAvailable = false;
    }
    maxAvailable.map((data, index) => {
      if(data !== '' && data !== null){
        totalMaxAvailable = parseInt(totalMaxAvailable) + parseInt(data);
      }
    });

    if (this.state.offerTitle.length === 0) {
      isError = true;
      this.setState({ offerTitleError: "red" });
      if(xCoordinate.key !== 'formOfferTitle'){
        let x = window.scrollX + document.querySelector('#formOfferTitle').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formOfferTitle').getBoundingClientRect().top - 89
        xCoordinate['formOfferTitle'] = x;
        yCoordinate['formOfferTitle'] = y;
      }
    }
    if (this.state.affiliateOption === true) {
    if (this.state.percentageOff.length === 0 || this.state.percentageOff >100) {
      isError = true;
      this.setState({ percentageOffError: "red" ,limitMessage: " (Please input between 0 to 100 )" });
      if(xCoordinate.key !== 'formPercentageOff'){
        let x = window.scrollX + document.querySelector('#formPercentageOff').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formPercentageOff').getBoundingClientRect().top - 89
        xCoordinate['formPercentageOff'] = x;
        yCoordinate['formPercentageOff'] = y;
      }
    }
  }
   if (this.state.affiliateOption === false) {
    if (this.state.retailPrice.length === 0) {
      isError = true;
      this.setState({ retailPriceError: "red" });
      if(xCoordinate.key !== 'formRetailPrice'){
        let x = window.scrollX + document.querySelector('#formRetailPrice').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formRetailPrice').getBoundingClientRect().top - 89
        xCoordinate['formRetailPrice'] = x;
        yCoordinate['formRetailPrice'] = y;
      }
    }
    if (this.state.offerPrice.length === 0) {
      isError = true;
      this.setState({ offerPriceError: "red" });
      if(xCoordinate.key !== 'formOfferPrice'){
        let x = window.scrollX + document.querySelector('#formOfferPrice').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formOfferPrice').getBoundingClientRect().top - 89
        xCoordinate['formOfferPrice'] = x;
        yCoordinate['formOfferPrice'] = y;
      }
    }
    if (this.state.freeShipping === "1") {
    if (this.state.shippingAmount.length === 0) {
      isError = true;
      this.setState({ shippingAmountError: "red" });
      if(xCoordinate.key !== 'formshippingAmountInput'){
        let x = window.scrollX + document.querySelector('#formshippingAmountInput').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formshippingAmountInput').getBoundingClientRect().top - 89
        xCoordinate['formshippingAmountInput'] = x;
        yCoordinate['formshippingAmountInput'] = y;
      }
    }
   }
   if (this.state.freeShipping === "1") {
    if (this.state.shippingAmountMerchant.length === 0) {
      isError = true;
      this.setState({ shippingAmountMerchantError: "red" });
      if(xCoordinate.key !== 'formshippingAmountMerchant'){
        let x = window.scrollX + document.querySelector('#formshippingAmountMerchant').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formshippingAmountMerchant').getBoundingClientRect().top - 89
        xCoordinate['formshippingAmountMerchant'] = x;
        yCoordinate['formshippingAmountMerchant'] = y;
      }
    }
  }
  if (this.state.freeShipping === "1") {
    if (this.state.shippingAmountAdmin.length === 0) {
      isError = true;
      this.setState({ shippingAmountAdminError: "red" });
      if(xCoordinate.key !== 'formshippingAmountAdmin'){
        let x = window.scrollX + document.querySelector('#formshippingAmountAdmin').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formshippingAmountAdmin').getBoundingClientRect().top - 89
        xCoordinate['formshippingAmountAdmin'] = x;
        yCoordinate['formshippingAmountAdmin'] = y;
      }
    }
  }
  if (this.state.freeShipping === "1") {
  if(this.state.shippingAmountAdmin || this.state.shippingAmountMerchant){
    shippingAmountAdminConst =
      this.state.shippingAmountAdmin !== 0 &&
      typeof this.state.shippingAmountMerchant !== "NaN"
      ? Number.parseFloat(this.state.shippingAmountAdmin)
      : 0;
      shippingAmountMerchantConst =
      this.state.shippingAmountMerchant !== 0 &&
      typeof this.state.shippingAmountMerchant !== "NaN"
      ? Number.parseFloat(this.state.shippingAmountMerchant)
      : 0;

      sumOfPercent = shippingAmountAdminConst + shippingAmountMerchantConst;
      if (sumOfPercent !== 100) {
        isError = true;
        this.setState({
          shippingAmountAdminError: "red",
          shippingAmountMerchantError: "red"
        });
        if (shippingAmountMerchant === "shippingAmountMerchant") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        } else if (shippingAmountAdmin === "shippingAmountAdmin") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        }
      }else if (sumOfPercent === 100) {
        this.setState({
          shippingAmountMerchantTooltipError: "",
          shippingAmountAdminTooltipError: "",
          shippingAmountMerchantError: "",
          shippingAmountAdminError: ""
        });
      }
    }
  }
}

    if (!this.state.merchantID) {
      isError = true;
      this.setState({ merchantIDError: "red" });
      if(xCoordinate.key !== 'formMerchantID'){
        let x = window.scrollX + document.querySelector('#formMerchantID').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formMerchantID').getBoundingClientRect().top - 89
        xCoordinate['formMerchantID'] = x;
        yCoordinate['formMerchantID'] = y;
      }
    }

    if (!this.state.merchantLegalName) {
      isError = true;
      this.setState({ merchantLegalNameError: "red" });
      if(xCoordinate.key !== 'formmerchantLegalName'){
        let x = window.scrollX + document.querySelector('#formmerchantLegalName').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formmerchantLegalName').getBoundingClientRect().top - 89
        xCoordinate['formmerchantLegalName'] = x;
        yCoordinate['formmerchantLegalName'] = y;
      }
    }

    if (this.state.affiliateOption === false) {
      if (!this.state.remittance) {
        isError = true;
        this.setState({ remittanceError: "red" });
        if(xCoordinate.key !== 'formMinQuantity'){
          let x = window.scrollX + document.querySelector('#formMinQuantity').getBoundingClientRect().left
          let y = window.scrollY + document.querySelector('#formMinQuantity').getBoundingClientRect().top - 89
          xCoordinate['formMinQuantity'] = x;
          yCoordinate['formMinQuantity'] = y;
        }
      }

      if (this.state.maxAsGift === '') {
        isError = true;
        this.setState({ maxAsGiftError: "red" });
        if(xCoordinate.key !== 'formMaxAsGift'){
          let x = window.scrollX + document.querySelector('#formMaxAsGift').getBoundingClientRect().left
          let y = window.scrollY + document.querySelector('#formMaxAsGift').getBoundingClientRect().top - 89
          xCoordinate['formMaxAsGift'] = x;
          yCoordinate['formMaxAsGift'] = y;
        }
      }
    }

    return isError;
  };

  additionalPrice = () => { 
    additionalPriceDetail = [];
    let constAdditionalData;

    // contractID
    if (contractIdParams == "") {
      //console.log('r_offerTitle3', r_offerTitle);
      for (let i = 0; i < r_offerTitle.length; i++) { 
        if(typeof r_offerTitle[i] != 'undefined' && r_offerTitle[i]!='' && typeof offerTitle[i] != 'undefined' && offerTitle[i]!=''){
          constAdditionalData = {
            offerTitle: offerTitle[i] ? offerTitle[i] : "",
            french_offerTitle: french_offerTitle[i] ? french_offerTitle[i] : "",
            minQuantity: minQuantity[i] ? minQuantity[i] : "",
            activateQuantity: activateQuantity[i] ? activateQuantity[i] : "", 
            skuCode: skuCode[i] ? skuCode[i] : "",
            maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
            maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
            retailPrice: retailPrice[i] ? retailPrice[i] : "",
            offerPrice: offerPrice[i] ? offerPrice[i] : "",
            remittance: remittance[i] ? remittance[i] : "",
            freeShipping: freeShipping[i] ? freeShipping[i] : "",
            shippingAmount: shippingAmount[i] ? shippingAmount[i] : "",
            shippingAmountMerchant: shippingAmountMerchant[i] ? shippingAmountMerchant[i] : "",
            shippingAmountAdmin: shippingAmountAdmin[i] ? shippingAmountAdmin[i] : "",
            maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
            attributes: attributeData[i] ? attributeData[i] : [],
            metrix: matrixData[i] ? matrixData[i] : "",
          };
          additionalPriceDetail.push(constAdditionalData);
        }
      }
    } else {
      //console.log('offerTitle', offerTitle);
      for (let i = 0; i < offerTitle.length; i++) {
        if(typeof offerTitle[i] != 'undefined' && offerTitle[i]!=''){
          constAdditionalData = {
            contractID: contractID[i] ? contractID[i] : "",
            offerTitle: offerTitle[i] ? offerTitle[i] : "",
            french_offerTitle: french_offerTitle[i] ? french_offerTitle[i] : "",
            minQuantity: minQuantity[i] ? minQuantity[i] : "",
            activateQuantity: activateQuantity[i] ? activateQuantity[i] : "",
            skuCode: skuCode[i] ? skuCode[i] : "",
            maxPerCustomer: maxPerCustomer[i] ? maxPerCustomer[i] : "",
            percentageOff: percentageOff[i] ? percentageOff[i] : "",
            maxAvailable: maxAvailable[i] ? maxAvailable[i] : "",
            retailPrice: retailPrice[i] ? retailPrice[i] : "",
            offerPrice: offerPrice[i] ? offerPrice[i] : "",
            remittance: remittance[i] ? remittance[i] : "",
            freeShipping: freeShipping[i] ? freeShipping[i] : "",
            shippingAmount: shippingAmount[i] ? shippingAmount[i] : "",
            shippingAmountMerchant: shippingAmountMerchant[i] ? shippingAmountMerchant[i] : "",
            shippingAmountAdmin: shippingAmountAdmin[i] ? shippingAmountAdmin[i] : "",
            maxAsGift: maxAsGift[i] ? maxAsGift[i] : "",
            attributes: attributeData[i] ? attributeData[i] : [],
            metrix: matrixData[i] ? matrixData[i] : ""
          };
          additionalPriceDetail.push(constAdditionalData);
          //console.log('additionalPriceDetail3', additionalPriceDetail);
        }
      }
      //console.log('additionalPriceDetail', additionalPriceDetail);
      if (this.state.contract) {
        this.state.contract.map((data, i) =>{
          if(data.attribute){
            data.attributes = (data.attribute) ? data.attribute : [];
            delete data["attribute"];
            additionalPriceDetail.push(data);
          } else{
            additionalPriceDetail.push(data);
          }      
        });
      }
      //console.log('additionalPriceDetail1', additionalPriceDetail);
    }
    this.setState({ deatil: additionalPriceDetail });
    //console.log('additionalPriceDetail2', additionalPriceDetail);
    return additionalPriceDetail;
  };

  validateShippingAmount = (additionalPrice) => {
    let error = true;
    additionalPrice.map((data, index) => {
        console.log(data.freeShipping, (parseInt(data.shippingAmountAdmin) + parseInt(data.shippingAmountMerchant)))
        if(data.freeShipping == 1 && (parseInt(data.shippingAmountAdmin) + parseInt(data.shippingAmountMerchant)) != 100){
          error = false;
        }
    });
    
    return error;
  }
  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    const additionalPrice = this.additionalPrice();
    const validateAmount = this.validateShippingAmount(additionalPrice);
    
    if (!err && validateAmount != false) {
      this.setState({ disabled: true });
      // const date = this.state.expirationDate ? this.state.expirationDate : null;
      if (this.state.contractID !== "") {
        if (contractIdParams !== "" && contractTypeParams == 'edit') {
           const postData = {
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            activateQuantity: this.state.activateQuantity,
          };
          //console.log('postData', postData);
          this.props.update_product(postData);
        }
        else if (contractIdParams !== "" && contractTypeParams == 'clone') {

          const postData = {
            cloneContractID: this.state.contractID,
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            activateQuantity: this.state.activateQuantity,
          };
          //console.log('postData', postData);
          this.props.clone_product_detail(postData);
        }
        else if (contractIdParams !== "" && contractTypeParams == 'clone-product') {

          const postData = {
            cloneContractID: this.state.contractID,
            proposal_type: this.state.contractType,
            affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
            paymentType: this.state.paymentType,
            paymentAmount: this.state.paymentAmount,
            paymentReceived: this.state.paymentReceived,
            paymentAmountReceived: this.state.paymentAmountReceived,
            service: this.state.service,
            price: this.state.pricing,
            creditCardType: this.state.creditCardType,
            creditCardNumber: this.state.creditCardNumber,
            cardExpirationDate: this.state.cardExpirationDate,
            securityNumber: this.state.securityNumber,
            cityID: this.state.cityID,
            detail: additionalPrice,
            merchantID: this.state.merchantID,
            merchantLegalName: this.state.merchantLegalName,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city ? this.state.city : "",
            state: this.state.state ? this.state.state : "",
            country: this.state.country ? this.state.country : "",
            addState: this.state.addState ? this.state.addState : "",
            addCity: this.state.addCity ? this.state.addCity : "",
            zip: this.state.zip,
            phone: this.state.phone,
            contactName: this.state.contactName,
            contactPhone: this.state.contactPhone,
            contactEmail: this.state.contactEmail,
            notes: this.state.notes,
            redeemedAtCall: this.state.redeemedAtCall,
            shipable: this.state.shipable,
            redemptionCodeReq: this.state.redemptionCodeReq,
            vouchersBeIssued: this.state.vouchersBeIssued,
            salesManagerID: this.state.salesManagerID,
            activateQuantity: this.state.activateQuantity,
          };
          //console.log('postData', postData);
          this.props.clone_product(postData);
        }
      } else {
        const postData = {
          proposal_type: this.state.contractType,
          affiliatePurchaseUrl: this.state.affiliatePurchaseUrl,
          paymentType: this.state.paymentType,
          paymentAmount: this.state.paymentAmount,
          paymentReceived: this.state.paymentReceived,
          paymentAmountReceived: this.state.paymentAmountReceived,
          service: this.state.service,
          price: this.state.pricing,
          creditCardType: this.state.creditCardType,
          creditCardNumber: this.state.creditCardNumber,
          cardExpirationDate: this.state.cardExpirationDate,
          securityNumber: this.state.securityNumber,
          cityID: this.state.cityID,
          detail: additionalPrice,
          merchantID: this.state.merchantID,
          merchantLegalName: this.state.merchantLegalName,
          address1: this.state.address1,
          address2: this.state.address2,
          city: this.state.city ? this.state.city : "",
          state: this.state.state ? this.state.state : "",
          country: this.state.country ? this.state.country : "",
          addState: this.state.addState ? this.state.addState : "",
          addCity: this.state.addCity ? this.state.addCity : "",
          zip: this.state.zip,
          phone: this.state.phone,
          contactName: this.state.contactName,
          contactPhone: this.state.contactPhone,
          contactEmail: this.state.contactEmail,
          notes: this.state.notes,
          redeemedAtCall: this.state.redeemedAtCall,
          shipable: this.state.shipable,
          redemptionCodeReq: this.state.redemptionCodeReq,
          vouchersBeIssued: this.state.vouchersBeIssued,
          salesManagerID: this.state.salesManagerID,
          activateQuantity: this.state.activateQuantity,

        };
        //console.log('postData', postData);
        this.props.add_product(postData);
      }
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
    }
  }

  Clear() {
    (this.state.contractType = "1"),
      (this.state.affiliatePurchaseUrl = ""),
      (this.state.paymentType = ""),
      (this.state.paymentAmount = ""),
      (this.state.paymentReceived = ""),
      (this.state.paymentAmountReceived = ""),
      (this.state.service = ""),
      (this.state.pricing = ""),
      (this.state.creditCardType = ""),
      (this.state.creditCardNumber = ""),
      (this.state.cardExpirationDate = ""),
      (this.state.securityNumber = ""),
      (this.state.cityID = ""),
      (this.state.merchantID = ""),
      (this.state.merchantLegalName = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.addState = ""),
      (this.state.addCity = ""),
      (this.state.zip = ""),
      (this.state.phone = ""),
      (this.state.contactName = ""),
      (this.state.contactPhone = ""),
      (this.state.contactEmail = ""),
      (this.state.notes = ""),
      (this.state.redeemedAtCall = ""),
      (this.state.shipable = ""),
      (this.state.redemptionCodeReq = ""),
      (this.state.vouchersBeIssued = "");
      (this.state.salesManagerID = ""),
      (this.state.offerTitle = ""),
      (this.state.french_offerTitle = ""),
      (this.state.percentageOff = ""),
      (this.state.maxAvailable = ""),
      (this.state.retailPrice = ""),
      (this.state.offerPrice = ""),
      (this.state.remittance = ""),
      (this.state.freeShipping = ""),
      (this.state.shippingAmount = ""),
      (this.state.shippingAmountMerchant = ""),
      (this.state.shippingAmountAdmin = ""),
      (this.state.maxPerCustomer = ""),
      (this.state.maxAsGift = ""),
      (this.state.startDate = ""),
      (this.state.minQuantity = ""),
      (this.state.activateQuantity = ""),
      (this.state.skuCode = ""),
      (this.state.contract = ""),
      this.setState({ attributes: "" }),
      (attributeData = []);
   
    additionalPriceDetail = [];
    priceIndex = 0;
    priceIndex = [];
    offerTitle = [];
    french_offerTitle = [];
    minQuantity = [];
    activateQuantity = [];
    skuCode = [];
    maxPerCustomer = [];
    percentageOff = [];
    maxAvailable = [];
    retailPrice = [];
    offerPrice = [];
    remittance = [];
    freeShipping = [];
    shippingAmount = [];
    shippingAmountMerchant = [];
    shippingAmountAdmin = [];
    maxAsGift = [];
    form = [];
    this.state.priceIndex = [];
  }

  onSelectedCountry = () => evt => {
    this.setState({ disabled: false });
    const selectedCountry = this.state.countryData.find(
      k => k.country == evt.target.value
    );
    this.setState({
      changeCountry: true,
      country: selectedCountry.country
    });
  };

  // onSelectedCountry = (val, key) => {
  //   this.setState({ disabled: false });
  //   this.setState({ country: val });
  //   if(this.state.country != val){
  //     this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
  //   }
  // };

  onSelectedState = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ state: val });
  };

  onSelectedCity = (val, key) => {
    this.setState({ disabled: false });
    this.setState({ city: val });
    this.setState({ cityID: key });
  };

  handlePageChange = page => {
    this.props.get_merchant_list({ page: 0 });
  };

  componentDidMount() {
    this.handlePageChange();
    this.props.getAllCountryData();
    this.props.ContractType();
    this.setState({ countryData: this.props.countries });
  }

  componentWillMount() {
    offerTitle = [];
    r_offerTitle = [];
    french_offerTitle = [];

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    priceIndex = 0;
    form = [];
    additionalPriceDetail = [];
    userinfo = auth.getUserInfo();

    this.props.clearAlert();
    this.handleDismiss();
    this.props.getSalesPersons();
    this.props.getPayoutDropdownList();

    contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";

    contractTypeParams = this.props.match.params.cType ? this.props.match.params.cType : "";
    if(this.props.match.params.contractId && this.props.match.params.cType){
      const editLink = `addProduct/${this.props.match.params.contractId}/${this.props.match.params.cType}`
      const path = ["Home", "Manage Product", "Edit Product"];
      const links = ["home","productList",editLink];
      this.setState({path:path, links:links})
    }
    if (contractIdParams !== "" && contractTypeParams == 'edit') {
      isLoading = "true";
      this.props.getProductDetails(contractIdParams);
    }
    else if (contractIdParams !== "" && contractTypeParams == 'clone') {
      isLoading = "true";
      this.props.getProductDetails(contractIdParams);
    }
    else if (contractIdParams !== "" && contractTypeParams == 'clone-product') {
      isLoading = "true";
      this.props.getProductDetails(contractIdParams);
    }
    else 
    {
      this.setState({ merchantID: contractIdParams });
      this.props.get_merchant_details_id({merchantId:contractIdParams});
    }
  }

  componentWillReceiveProps(nextProps) {
    let menuAclKey = this.state.menuKey;
    if(this.props.match.params.cType == 'edit'){
      menuAclKey = 'EDIT_PRODUCTS';
    }
    if(!aclUtil.isPrimaryMenuAccessible(menuAclKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.countries !== nextProps.countries) {
      this.setState({ countryData: nextProps.countries });
    }
    
    if (this.props.merchantDetails !== nextProps.merchantDetails) {
      if (nextProps.merchantDetails) {
        isLoading = "false";
        const contactNameConst = `${nextProps.merchantDetails.firstName} ${
          nextProps.merchantDetails.lastName
        }`;

        this.setState({
          merchantID: nextProps.merchantDetails.merchant_id,
          merchantLegalName: nextProps.merchantDetails.legalName,
          address1: nextProps.merchantDetails.address1,
          address2: nextProps.merchantDetails.address2,
          phone: nextProps.merchantDetails.phone,
          zip: nextProps.merchantDetails.zipcode,
          city: nextProps.merchantDetails.city,
          country: nextProps.merchantDetails.country,
          cityID: nextProps.merchantDetails.cityID,
          state: nextProps.merchantDetails.state,
          addCity: nextProps.merchantDetails.addCity,
          addState: nextProps.merchantDetails.addState,
          dealID: nextProps.merchantDetails.dealID
        });
      }
    }

    if (this.props.addContractResponse !== nextProps.addContractResponse) {
      if (nextProps.addContractResponse) {
        console.log('nextProps.addContractResponse.data',nextProps.addContractResponse)
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addContractResponse.message
        );
        this.setState({ disabled: false });
        isLoading = "false";
        this.state.clearAttributes = true;
        this.onSelectedCountry();
        this.Clear();
        this.context.router.history.push(`/editProduct/${nextProps.addContractResponse.productDealID}`);
      }
      window.scrollTo(0, 0);
    }

    if (this.props.updatedContract !== nextProps.updatedContract) {
      if (nextProps.updatedContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.context.router.history.push(`/editProduct/${nextProps.updatedContract.productDealID}`);
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.cloneContract !== nextProps.cloneContract) {
      if (nextProps.cloneContract) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.cloneContract.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.cloneContractNonExecuted !== nextProps.cloneContractNonExecuted) {
      if (nextProps.cloneContractNonExecuted) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.cloneContractNonExecuted.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.merchantList !== nextProps.merchantList) {
      if (nextProps.merchantList) {
        this.setState({ merchantList: nextProps.merchantList });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        window.scrollTo(0, 0);
        this.setState({ disabled: false });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }

    if (
      this.props.salesPersonList !== nextProps.salesPersonList &&
      !isEmpty(nextProps.salesPersonList)
    ) {
      this.setState({ salespersonlist: nextProps.salesPersonList.data.data });
    }

    if (this.props.contractDetails !== nextProps.contractDetails) {
      if (nextProps.contractDetails) {
        priceIndex = [];
        isLoading = "false";
        this.setState({ userDetailsForEdit: nextProps.contractDetails.data });
        let contract = nextProps.contractDetails.data;
        if (contract.proposal_type === "7") {
          this.setState({ affiliateOption: true });
        } else if (contract.proposal_type === "6") {
          this.setState({ coupoOption: true });
        }
        this.setState({
          contractID: contract.contractID,
          contractType: contract.proposal_type,
          affiliatePurchaseUrl: contract.affiliatePurchaseUrl,
          paymentType: contract.paymentType,
          paymentAmount: contract.paymentAmount,
          paymentReceived: contract.paymentReceived,
          paymentAmountReceived: contract.paymentAmountReceived,
          service: contract.service,
          pricing: contract.price,
          creditCardType: contract.creditCardType,
          creditCardNumber: contract.creditCardNumber,
          cardExpirationDate: contract.cardExpirationDate,
          securityNumber: contract.securityNumber,
          parentID: contract.parentID,
          offerTitle: contract.offerTitle,
          french_offerTitle: contract.french_offerTitle,
          minQuantity: contract.minQuantity,
          activateQuantity: contract.activateQuantity,
          skuCode: contract.skuCode,
          percentageOff: contract.percentageOff,
          maxAvailable: contract.maxAvailable,
          retailPrice: contract.retailPrice,
          offerPrice: contract.offerPrice,
          remittance: contract.remittance,
          freeShipping: contract.freeShipping,
          shippingAmount: contract.shippingAmount,
          shippingAmountMerchant: contract.shippingAmountMerchant,
          shippingAmountAdmin: contract.shippingAmountAdmin,
          maxPerCustomer: contract.maxPerCustomer,
          maxAsGift: contract.maxAsGift,
          merchantID: contract.merchantID,
          merchantLegalName: contract.merchantLegalName,
          address1: contract.address1,
          address2: contract.address2,
          city: contract.city,
          addCity: contract.addCity,
          country: contract.country,
          cityID: contract.cityID,
          state: contract.state,
          addState: contract.addState,
          zip: contract.zip,
          phone: contract.phone,
          contactName: contract.contactName,
          contactEmail: contract.contactEmail,
          contactPhone: contract.contactPhone,
          notes: contract.notes,
          redeemedAtCall: contract.redeemedAtCall,
          shipable: contract.shipable,
          redemptionCodeReq: contract.redemptionCodeReq,
          vouchersBeIssued: contract.vouchersBeIssued,
          salesManagerID: contract.salesManagerID,
          attributes: contract.attribute,
          contract: contract.child_contracts,
          metrix: contract.metrix, 
        });
        //console.log('contract.child_contracts', contract.child_contracts);
        if (!isEmpty(contract.child_contracts)) {
          offerTitle = [];
          r_offerTitle = [];
          french_offerTitle = [];
          minQuantity = [];
          activateQuantity= [];
          skuCode = [];
          maxPerCustomer = [];
          percentageOff = [];
          maxAvailable = [];
          retailPrice = [];
          offerPrice = [];
          remittance = [];
          freeShipping = [];
          shippingAmount = [];
          shippingAmountMerchant = [];
          shippingAmountAdmin = [];
          maxAsGift = [];
          attributeData = [];
          additionalPriceDetail = [];
          matrixData = [];
          priceIndex = 0;
          form = [];
          additionalPriceDetail = [];
          contract.child_contracts.map((data, index) =>
            this.editPricingDetail(data)
          );
        }

        this.attributeData(contract.attribute, 0);

        if (contract.contractID) {
          this.handleContractIDChange(contract.contractID, 0);
        }
        if (contract.offerTitle) {
          this.handleOfferChange(contract.offerTitle, 0);
        }
        if (contract.french_offerTitle) {
          this.handleFrenchOfferChange(contract.french_offerTitle, 0);
        }
        if (contract.minQuantity) {
          this.handleminQuantityChange(contract.minQuantity, 0);
        }

        if (contract.activateQuantity) {
          this.handleActiveQuantityChange(contract.activateQuantity, 0);
        }
        
        if (contract.skuCode) {
          this.handleskuCodeChange(contract.skuCode, 0);
        }
        if (contract.maxPerCustomer) {
          this.handlemaxPerCustomerChange(contract.maxPerCustomer, 0);
        }
        if (contract.percentageOff) {
          this.handlepercentageOffChange(contract.percentageOff, 0);
        }
        if (contract.maxAvailable) {
          this.handlemaxAvailableChange(contract.maxAvailable, 0);
        }
        if (contract.retailPrice) {
          this.handleretailPriceChange(contract.retailPrice, 0);
        }
        if (contract.offerPrice) {
          this.handleofferPriceChange(contract.offerPrice, 0);
        }
        if (contract.remittance) {
          this.handleremittanceChange(contract.remittance, 0);
        }
        if (contract.freeShipping) {
          this.handlefreeShippingChange(contract.freeShipping, 0);
        }
        if (contract.shippingAmount) {
          this.handleshippingAmountChange(contract.shippingAmount, 0);
        }
        if (contract.shippingAmountMerchant) {
          this.handleshippingAmountMerchantChange(contract.shippingAmountMerchant, 0);
        }
        if (contract.shippingAmountAdmin) {
          this.handleshippingAmountAdminChange(contract.shippingAmountAdmin, 0);
        }
        if (contract.maxAsGift) {
          this.handlemaxAsGiftChange(contract.maxAsGift, 0);
        }
      }
    }

    if(this.props.payoutList !== nextProps.payoutList){
      if(nextProps.payoutList){
        isLoading="false";
        this.setState({payoutList: nextProps.payoutList.data})
      }
    }
  }

  getValidationOfferTitle() {
    const length = this.state.offerTitle.length;
    if (length < 2) return "error";
    return null;
  }

  getValidationNotes() {
    if (this.state.notes) {
      const length = this.state.notes.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationminQuantity() {
    const length = this.state.minQuantity.length;
    if (length >= 1) return "success";
    else if (length === 0) return "error";
    return null;
  }

  getValidationskuCode() {
    if (this.state.skuCode) {
      const length = this.state.skuCode.length;
      if (length < 2) return "error";
    }

    return null;
  }

  getValidationmaxPerCustomer() {
    if (this.state.maxPerCustomer) {
      const length = this.state.maxPerCustomer.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationmaxAsGift() {
    if (this.state.maxAsGift) {
      const length = this.state.maxAsGift.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationpercentageOff() {
    const length = this.state.percentageOff.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationmaxAvailable() {
    if (this.state.maxAvailable) {
      const length = this.state.maxAvailable.length;
      if (length >= 1) return "success";
      else if (length > 0) return "error";
    }
    return null;
  }

  getValidationretailPrice() {
    const length = this.state.retailPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationofferPrice() {
    const length = this.state.offerPrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationremittance() {
    const length = this.state.remittance.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationPhoneState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationmerchantID() {
    const length = this.state.merchantID.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }
  getValidationcreditCardType() {
    const length = this.state.creditCardType.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationcreditCardNumber() {
    if (this.state.creditCardNumber) {
      const length = this.state.creditCardNumber.length;
      if (length < 16) return "error";
    }

    return null;
  }

  getValidationcardExpirationDate() {
    if (this.state.cardExpirationDate) {
      const length = this.state.cardExpirationDate.length;
      if (length < 4) return "errror";
    }

    return null;
  }

  getValidationsecurityNumber() {
    if (this.state.securityNumber) {
      const length = this.state.securityNumber.length;
      if (length < 3) return "warning";
    }

    return null;
  }

  render() {
    let contract =
      this.props.contractDetails && this.props.contractDetails.merchantLegalName
        ? this.props.contractDetails
        : {};

    let merchantListData = this.state.merchantList
      ? this.state.merchantList
      : [];
    let merchantListItem;

    let countrydata = this.state.countryData ? this.state.countryData : [];
    let countryItems, stateItems, cityItems;

    if (countrydata) {
      countryItems = countrydata.map((countryObject, phyidx) => (
        <option key={phyidx} value={countryObject.country}>
          {countryObject.countryName}
        </option>
      ));
    }

    let salesManagerItems;
    let salespersonData = this.state.salespersonlist
      ? this.state.salespersonlist
      : "";
    if (salespersonData !== "") {
      salesManagerItems = salespersonData.map((salesObject, index) => (
        <option key={index} value={salesObject.user_id}>
          {salesObject.userName}
        </option>
      ));
    }

    let remittancePercentage;
    if(this.state.offerPrice !=''){
      remittancePercentage = parseFloat((this.state.offerPrice > 0 ? ((this.state.offerPrice - this.state.remittance) / this.state.offerPrice) :0) * 100).toFixed(2); 
    }else{
      remittancePercentage = '0.00';
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.sendingMerchantDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
        {/**start merchant information **/}
          <div className="panel">
            <header className="panel-heading">Merchant Information</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
            )}
            <div className="panel-body">
            {isLoading == "true" ? (
                <div className="loader">
                  <p className="loading-message">
                    <i>Loading...</i>
                  </p>
                  <div className="spinner">
                    <div className="dot1" />
                    <div className="dot2" />
                  </div>
                </div>
              ) : (
                ""
            )}
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Merchant Name
                    </ControlLabel>
                    <FormGroup
                      controlId="formMerchantID"
                      validationState={this.getValidationmerchantID()}
                    >
                      <FormControl
                        componentClass="select"
                        name="merchantID"
                        onChange={this.handleChangeMerchant}
                        value={this.state.merchantID}
                        style={{ borderColor: this.state.merchantIDError }}
                      >
                        <option value="">Choose Merchant Name</option>
                        {merchantListData.map((el, key) => {
                          return (
                            <option key={key} value={el.merchantID}>
                              {el.merchantName}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formMerchantLegalName">
                      <ControlLabel><span style={{ color: "red" }}>*</span> Merchant Legal Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.merchantLegalName}
                        placeholder="Minimum Legal Name"
                        onChange={this.handleChange}
                        name="merchantLegalName"
                        style={{ borderColor: this.state.merchantLegalNameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress1">
                      <ControlLabel>Address 1</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address1}
                        placeholder="Address 1"
                        onChange={this.handleChange}
                        name="address1"
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress2">
                      <ControlLabel>Address 2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address2}
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        name="address2"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4} xs={12}>
                    <div className="form-group" id="primaryContactInfoCountry">
                      <label htmlFor="country">
                        <span style={{ color: "red" }}>*</span> Country
                      </label>
                      <select
                        name="Country"
                        className="form-control"
                        style={{ borderColor: this.state.countryError }}
                        value={this.state.country}
                        onChange={this.onSelectedCountry()}
                      >
                        <option key="select default">
                          Select a country
                        </option>
                        {countryItems}
                      </select>
                    </div>
                    <FormGroup controlId="formBasicAddStateText">
                      <ControlLabel><span style={{ color: 'red' }}>*</span>State</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.addState}
                        placeholder="Enter State"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.addStateError }}
                        name="addState"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicAddCityText">
                      <ControlLabel><span style={{ color: 'red' }}>*</span>City</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.addCity}
                        placeholder="Enter City"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.addCityError }}
                        name="addCity"
                      />
                    </FormGroup>
                    <FormGroup controlId="formZipCode">
                      <ControlLabel>Zip Code</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zip}
                        placeholder="Zip Code"
                        onChange={this.handleChange}
                        name="zip"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      Phone Number (format: xxx-xxx-xxxx)
                    </ControlLabel>
                    <FormGroup
                      controlId="formPhoneNunber"
                      validationState={this.getValidationPhoneState()}
                    >
                       <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactName">
                      <ControlLabel>Contact Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.contactName}
                        placeholder="Contact Name"
                        onChange={this.handleChange}
                        name="contactName"
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactPhone">
                      <ControlLabel>Contact Phone</ControlLabel>
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="contactPhone"
                        placeholder="Contact Phone"
                        value={this.state.contactPhone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="formContactEmail">
                      <ControlLabel>Contact Email</ControlLabel>
                      <FormControl
                        type="email"
                        value={this.state.contactEmail}
                        placeholder="Contact Email"
                        onChange={this.handleChange}
                        name="contactEmail"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        {/**end merchant information **/}

          {/**start contract price information **/}
          <div className="panel">          
            <header className="panel-heading">
              Product Details{" "}
              {this.state.affiliateOption == false ? (
              <Button
                bsSize="small"
                onClick={this.addPricingDetail}
                bsStyle="success"
                className="pull-right"
              >
                Add Additional Price
              </Button>
              ) : null}
            </header>            
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Product Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.offerTitle}
                        placeholder="Product Title"
                        onChange={this.handleChangeAditionalPrice}
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {(this.state.multi_lang == "yes") &&
                      <FormGroup controlId="formfrench_OfferTitle">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span> Product Title (Canadian French)
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.french_offerTitle}
                          placeholder="Product Title"
                          onChange={this.handleChangeAditionalPrice}
                          name="french_offerTitle"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    }
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>Minimum Quantity Required Per Customer</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formMinQuantity">
                        <FormControl
                          type="text"
                          value={this.state.minQuantity}
                          placeholder="Minimum Quantity Required Per Customer"
                          onChange={this.handleChangeAditionalPrice}
                          name="minQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.affiliateOption == false /*false*/ ? (
                      <ControlLabel>Minimum Quantity Required To Activate Product</ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false /*false*/ ? (
                      <FormGroup controlId="formactivateQuantity">
                        <FormControl
                          type="text"
                          value={this.state.activateQuantity}
                          placeholder="Minimum Quantity Required To Activate Product"
                          onChange={this.handleChangeAditionalPrice}
                          name="activateQuantity"
                          style={{ borderColor: this.state.minQuantityError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        SKU #
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formSkuCode"
                        validationState={this.getValidationskuCode()}
                      >
                        <FormControl
                          type="text"
                          value={this.state.skuCode}
                          placeholder="SKU Code"
                          onChange={this.handleChangeAditionalPrice}
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                         Max Per Customer
                        (leave blank for an unlimited amount)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxPerCustomer"
                        validationState={this.getValidationmaxPerCustomer()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxPerCustomer}
                          placeholder="Max Per Customer"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxPerCustomer"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Max As Gifts (Do
                        not leave blank. Add 0 for no additional vouchers. No
                        unlimited option)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup
                        controlId="formMaxAsGift"
                        validationState={this.getValidationmaxAsGift()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.maxAsGift}
                          placeholder="Max As Gifts"
                          onChange={this.handleChangeAditionalPrice}
                          name="maxAsGift"
                          style={{ borderColor: this.state.maxAsGiftError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={6} xs={12}>
                  {this.state.affiliateOption == true ? (
                  <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Percentage Off (Input 0-100)    
                      {this.state.hideMsg == true ? (
                        <span style={{ color: "red" }}>{this.state.limitMessage}</span>
                      ) : null}  
                    </ControlLabel>
                  ) : null}
                  {this.state.affiliateOption == true ? (
                    <FormGroup controlId="formPercentageOff">
                      <FormControl
                        type="number"
                        value={this.state.percentageOff}
                        placeholder="Percentage Off"
                        onChange={this.handleChangeAditionalPrice}
                        name="percentageOff"
                        style={{ borderColor: this.state.percentageOffError }}

                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    ) : null}
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Maximum Available
                    </ControlLabel>
                    <FormGroup controlId="formMaxAvailable">
                      <FormControl
                        type="number"
                        value={this.state.maxAvailable}
                        placeholder="Maximum Available"
                        onChange={this.handleChangeAditionalPrice}
                        name="maxAvailable"
                        style={{ borderColor: this.state.maxAvailableError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Retail Price
                    </ControlLabel>
                    <FormGroup controlId="formRetailPrice">
                      <FormControl
                        type="number"
                        value={this.state.retailPrice}
                        placeholder="Retail Price"
                        onChange={this.handleChangeAditionalPrice}
                        name="retailPrice"
                        style={{ borderColor: this.state.retailPriceError }}
                        readOnly = {this.state.affiliateOption == false ? false : true}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Product Price
                    </ControlLabel>
                    <FormGroup controlId="formOfferPrice">
                      <FormControl
                        type="number"
                        value={this.state.offerPrice}
                        placeholder="Product Price"
                        onChange={this.handleChangeAditionalPrice}
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                        readOnly = {this.state.affiliateOption == false ? false : true}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Set Shipping Amount?
                    </ControlLabel>
                    <FormGroup controlId="formShippingAmount">
                        <FormControl
                          componentClass="select"
                          name="freeShipping"
                          onChange={this.handleChangeAditionalPrice}
                          value={(this.state.freeShipping) ? this.state.freeShipping : ""}
                          placeholder="select"
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                    </FormGroup>
                    {this.state.freeShipping == "1" ? (
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Shipping Amount
                    </ControlLabel>
                    ) : null}
                    {this.state.freeShipping == "1" ? (
                    <FormGroup controlId="formshippingAmountInput">
                      <FormControl
                        type="number"
                        value={(this.state.shippingAmount) ? this.state.shippingAmount : ""}
                        placeholder="Shipping Amount"
                        onChange={this.handleChangeAditionalPrice}
                        name="shippingAmount"
                        style={{ borderColor: this.state.shippingAmountError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    ) : null}
                    {this.state.freeShipping == "1" ? (
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Merchant Shipping %
                    </ControlLabel>
                    ) : null}
                    {this.state.freeShipping == "1" ? (
                    <FormGroup controlId="formshippingAmountMerchant">
                      <FormControl
                        type="number"
                        value={(this.state.shippingAmountMerchant) ? this.state.shippingAmountMerchant : ""}
                        placeholder="Merchant Shipping %"
                        onChange={this.handleChangeAditionalPrice}
                        onBlur={this.handleShippingPercent}
                        name="shippingAmountMerchant"
                        style={{borderColor: this.state.shippingAmountMerchantError}}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    ) : null}
                    {this.state.freeShipping == "1" ? (
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Admin Shipping %
                    </ControlLabel>
                    ) : null}
                    {this.state.freeShipping == "1" ? (
                    <FormGroup controlId="formshippingAmountAdmin">
                      <FormControl
                        type="number"
                        value={(this.state.shippingAmountAdmin) ? this.state.shippingAmountAdmin : ""}
                        placeholder="Admin Shipping %"
                        onChange={this.handleChangeAditionalPrice}
                        onBlur={this.handleShippingPercent}
                        name="shippingAmountAdmin"
                        style={{borderColor: this.state.shippingAmountAdminError}}
                      />
                      <FormControl.Feedback />
                      {this.state.shippingAmountAdminTooltipError && (
                            <Tooltip
                              placement="bottom"
                              className="in"
                              id="tooltip-top"
                              style={{ marginLeft: "386px", marginTop: "36px" }}
                            >
                              {this.state.shippingAmountAdminTooltipError}
                            </Tooltip>
                      )}
                    </FormGroup>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) ({remittancePercentage} % Margin)
                      </ControlLabel>
                    ) : null}
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          value={this.state.remittance}
                          placeholder="Remittance Per Unit"
                          onChange={this.handleChangeAditionalPrice}
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}

                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <Attributes
                      indexKey={0}
                      attributeData={this.attributeData}
                      matrixData={this.matrixData}
                      postAttributes={this.state.attributes}
                      postMatrix={this.state.metrix}
                      clearStatus={this.state.clearAttributes}
                      key={Math.random()}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {this.state.priceIndex.map((price, idx) => price)}
          {/**end contract price information **/}

          {/**start contract affiliate information **/}
          {this.state.affiliateOption == true ? (
            <div className="panel">
              <header className="panel-heading">GET ACCESS CONTRACT</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formaffiliatePurchaseUrl">
                        <ControlLabel>Affiliate Purchase URL</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.affiliatePurchaseUrl}
                          name="affiliatePurchaseUrl"
                          placeholder=""
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentType">
                        <ControlLabel>Payment type</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentType"
                          onChange={this.handleChange}
                          value={this.state.paymentType}
                        >
                          <option value="Fixed Fee">Fixed Fee</option>
                          <option value="Pay per voucher">Pay Per Voucher</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formpaymentAmount">
                        <ControlLabel>Payment amount</ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.paymentAmount}
                          placeholder="Amount"
                          onChange={this.handleChange}
                          name="paymentAmount"
                        />
                      </FormGroup>
                      <FormGroup controlId="formpaymentReceived">
                        <ControlLabel>Payment received?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="paymentReceived"
                          onChange={this.handlePaymentReceived}
                          value={this.state.paymentReceived}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                      {this.state.paymentAmountReceivedStatus === true ? (
                        <FormGroup controlId="formpaymentAmountReceived">
                          <ControlLabel>Payment amount received</ControlLabel>
                          <FormControl
                            type="number"
                            value={this.state.paymentAmountReceived}
                            placeholder="paymentAmountReceived"
                            onChange={this.handleChange}
                            name="paymentAmountReceived"
                          />
                        </FormGroup>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**start contract affiliate information **/}

          {/**start contract coupon information **/}
          {this.state.coupoOption === true ? (
            <div className="panel">
              <header className="panel-heading">Coupon Options</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formService">
                        <ControlLabel>Service</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.service}
                          name="service"
                          placeholder="Service (ex - red, blue)"
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup controlId="formPricing">
                        <ControlLabel>Pricing</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.pricing}
                          placeholder="Pricing ex - (10, 100)"
                          onChange={this.handleChange}
                          name="pricing"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formCreditCardType">
                        <ControlLabel>
                          Merchant Billing Information
                        </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formRetailPrice">
                        <ControlLabel>Credit Card Type</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.creditCardType}
                          placeholder="Credit Card Type"
                          onChange={this.handleChange}
                          name="creditCardType"
                          style={{
                            borderColor: this.state.creditCardTypeError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Credit Card Number</ControlLabel>
                      <FormGroup
                        controlId="formCreditCardNumber"
                        validationState={this.getValidationcreditCardNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.creditCardNumber}
                          placeholder="Card Mumber"
                          onChange={this.handleChange}
                          name="creditCardNumber"
                          style={{
                            borderColor: this.state.creditCardNumberError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Expiration Date (MMYY)</ControlLabel>
                      <FormGroup
                        controlId="formCardExpirationDate"
                        validationState={this.getValidationcardExpirationDate()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.cardExpirationDate}
                          placeholder="Expiration Date"
                          onChange={this.handleChange}
                          name="cardExpirationDate"
                          style={{
                            borderColor: this.state.cardExpirationDateError
                          }}
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      <ControlLabel>Security Code</ControlLabel>
                      <FormGroup
                        controlId="formSecurityNumber"
                        validationState={this.getValidationsecurityNumber()}
                      >
                        <FormControl
                          type="number"
                          value={this.state.securityNumber}
                          placeholder="Security Code"
                          onChange={this.handleChange}
                          name="securityNumber"
                          style={{
                            borderColor: this.state.securityNumberError
                          }}
                          minLength="3"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**end contract coupon information **/}

                    {/**start additional option **/}
          {this.state.affiliateOption == false ? (
            <div className="panel">
              <header className="panel-heading">Additional Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formShipable">
                        <ControlLabel>
                          Will this product be shipped to the customer?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="shipable"
                          onChange={this.handleChange}
                          value={this.state.shipable}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : null}
          {/**end additional option **/}
          <div className="panel">
              <header className="panel-heading">Additional Notes</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formNotes">
                        <FormControl
                          style={{
                            borderColor: this.state.notesError
                          }}
                          value={this.state.notes}
                          componentClass="textarea"
                          rows={6}
                          onChange={this.handleChange}
                          name="notes"
                          placeholder="Additonal Notes"
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
          </div>

          {userinfo.userTypeName !== "salesmanager" ? (
            <div className="panel">
              <header className="panel-heading">Administrative Option</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formControlsSelect">
                        <ControlLabel> Sales Person</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="salesManagerID"
                          value={this.state.salesManagerID}
                          onChange={this.handleChange}
                        >
                          <option>Select Sales Person</option>
                          {salesManagerItems}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="schedule"
                data-key="schedule"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/contractList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => { 
  return {
    merchantList: state.merchantReducer.merchantList,
    countries: state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    contractDetails: state.contractReducer.contractDetail,
    updatedContract: state.contractReducer.updatedContract,
    cloneContract: state.contractReducer.cloneContract,
    cloneContractNonExecuted: state.contractReducer.cloneContractNonExecuted,
    merchantDetails: state.merchantReducer.merchantDetails,
    sendingMerchantDetails: state.merchantReducer.sendingMerchantDetails,
    addContractResponse: state.contractReducer.addContractResponse,
    ProposalType: state.contractReducer.ContractType,
    error: state.contractReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    salesPersonList: state.salesPersonReducer.salesPersonList,
    payoutList:  state.payoutReducer.payoutList,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    add_product,
    get_merchant_list,
    renderAlert,
    clearAlert,
    getProductDetails,
    update_product,
    clone_product_detail,
    clone_product,
    get_merchant_details_id,
    getSalesPersons,
    getPayoutDropdownList,
    getAllCountryData,
    ContractType,
  })
)(AddProduct);


// WEBPACK FOOTER //
// ./src/app/views/admin/product/AddProduct.js